import * as _ from 'lodash';

import { IdObjectValue } from './id-object-value';

export type PrimitiveValueType = string | number | boolean | string[];
export interface IdPrimitiveValue<T extends PrimitiveValueType>
  extends IdObjectValue.Crud.Updatable {
  value: T | null;
}

export type IdPrimitiveValueCollection<T extends PrimitiveValueType> = {
  [id: string]: T | null;
};

export function toIdPrimitiveValueCollection<T extends PrimitiveValueType>(
  values: IdPrimitiveValue<T>[]
): IdPrimitiveValueCollection<T> {
  const result: IdPrimitiveValueCollection<T> = {};
  _.forEach(values, (v) => {
    result[v.id] = v.deleted ? null : v.value;
  });
  return result;
}

export function toNativePrimitiveArray<T extends PrimitiveValueType>(
  value: IdPrimitiveValueCollection<T>
): IdPrimitiveValue<T>[] {
  const result: IdPrimitiveValue<T>[] = [];
  _.forIn(value, (v, k) => {
    result.push({
      id: k,
      value: v,
      created: false,
      deleted: false
    });
  });
  return result;
}
